import AppMainGameplay from './app-main-gameplay';

export default AppMainGameplay;
